document.addEventListener('turbolinks:load', () => {
    const guidedLexiconPreview = document.getElementById('guidedLexiconPreview')
    const sgScreen = document.getElementById('sgScreen')
    const lexiconSearchInputLabel = document.getElementById('lexiconSearchInputLabel')
    const lexiconSearchInput = document.getElementById('lexiconSearchInput')


    if (guidedLexiconPreview !== null && sgScreen !== null && lexiconSearchInputLabel !== null && lexiconSearchInput !== null) {

        resize()
        initLexiconSearchInput()
    }

    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenHeight = sgScreen.getBoundingClientRect().height

            // input
            lexiconSearchInput.style.fontSize = `${currentSgScreenHeight / 45}px`
            lexiconSearchInput.style.lineHeight = `${currentSgScreenHeight / 45}px`
        })
        resizeObserver.observe(sgScreen);
    }

    // shoe floating label for input if active
    function initLexiconSearchInput() {
        lexiconSearchInput.addEventListener("focus", function() {
            lexiconSearchInputLabel.classList.remove('hidden')
        });


        lexiconSearchInput.addEventListener("blur", function() {
            lexiconSearchInputLabel.classList.add('hidden')
        });

        lexiconSearchInput.addEventListener("change", searchNames)
    }

    function searchNames() {
        let search_str = lexiconSearchInput.value
        for (let station of document.getElementsByClassName("guideLexiconItem")){
            if (station.dataset.station_name.includes(search_str)){
                station.classList.remove('hidden')
            } else {
                station.classList.add('hidden')
            }
        }
    }
})